var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOfferDiscountIcon = function SvgOfferDiscountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#OfferDiscountIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.727 6.734c-.25-.208-.408-.345-.464-.554-.058-.208.006-.403.117-.705.139-.38.329-.899-.005-1.459-.334-.561-.893-.66-1.302-.734-.325-.058-.531-.101-.688-.254-.158-.152-.202-.353-.263-.668-.074-.396-.178-.937-.756-1.261-.577-.323-1.113-.14-1.506-.005-.312.108-.515.17-.728.114-.214-.056-.357-.208-.57-.45C13.292.45 12.923 0 12.254 0c-.668 0-1.037.451-1.307.757-.213.243-.356.395-.57.451-.214.056-.415-.006-.728-.114-.393-.136-.93-.318-1.506.005-.578.324-.682.865-.756 1.261-.06.315-.105.516-.263.668-.157.153-.364.196-.689.254-.408.073-.967.173-1.3.734-.335.56-.145 1.08-.006 1.459.11.302.175.497.117.705-.057.209-.214.346-.465.554C4.465 6.994 4 7.353 4 8s.465 1.005.781 1.266c.25.208.408.345.465.554.058.208-.007.403-.117.705-.139.38-.329.899.005 1.459.334.561.893.66 1.301.734.325.058.532.101.689.254.158.152.202.353.263.668.074.396.178.937.756 1.261.577.322 1.114.14 1.506.005.313-.107.514-.169.727-.114.215.056.357.208.571.45.27.307.639.758 1.307.758.67 0 1.038-.451 1.308-.757.213-.243.356-.395.57-.451.213-.055.416.007.728.114.392.134.928.317 1.506-.005.578-.324.681-.865.756-1.261.06-.315.105-.516.263-.668.157-.153.363-.196.688-.254.409-.073.968-.173 1.301-.734.335-.56.145-1.08.006-1.459-.11-.302-.175-.497-.117-.705.056-.209.214-.346.464-.554.317-.26.782-.619.782-1.266s-.465-1.005-.782-1.266Z",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.302 6.923c0-.764-.64-1.385-1.428-1.385-.788 0-1.43.621-1.43 1.385 0 .763.642 1.384 1.43 1.384.787 0 1.428-.621 1.428-1.385Zm3.334 1.384c-.788 0-1.429.62-1.429 1.384 0 .764.64 1.385 1.429 1.385.787 0 1.428-.621 1.428-1.385 0-.763-.64-1.384-1.428-1.384Zm-.848-2.596a.489.489 0 0 1 .67-.072c.205.16.237.45.074.65l-3.81 4.614a.487.487 0 0 1-.67.073.453.453 0 0 1-.074-.65l3.81-4.615Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "OfferDiscountIcon_svg__a",
    x: 0,
    y: 0,
    width: 24.509,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_652_9236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_652_9236",
    result: "shape"
  })))));
};
export default SvgOfferDiscountIcon;